import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./command-menu-footer.css?inline";

@customElement("eko-command-menu-footer")
export class CommandMenuFooter extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`
      <div class="eko-command-menu-footer__left" part="left">
        <slot name="left"></slot>
      </div>
      <div class="eko-command-menu-footer__right" part="right">
        <slot name="right"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-command-menu-footer": CommandMenuFooter;
  }
}

export default CommandMenuFooter;
